export const searchNavData = [
    {
        id: 1,
        text: 'All',
        icon: 'target'
    },
    {
        id: 2,
        text: 'Images',
        icon: 'image'
    },
    {
        id: 3,
        text: 'Videos',
        icon: 'video-clapper'
    },
    {
        id: 4,
        text: 'Audios',
        icon: 'volume'
    },
    {
        id: 5,
        text: 'Settings',
        icon: 'settings',
        itemClass: 'bg-light-success',
        linkClass: 'txt-success'
    },
    {
        id: 6,
        text: 'Tools',
        icon: 'map-alt',
        itemClass: 'bg-light-secondary',
        linkClass: 'txt-secondary'
    },
]